import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/betShopManagement/configuration/generateToken/filter'; // Importing Filters component
import Table from 'views/betShopManagement/configuration/generateToken/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the generateTokenBetShopView.
 * @extends JetView
 */
export default class generateTokenBetShopView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left side layout configuration
        const left = {
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying theme to the toolbar
                    elements: [
                        {
                            view: 'label',
                            label: _('Generar Token'), // Localized label for "Generate Token"
                            width: 150,
                        },
                    ],
                },
                Filters, // Adding Filters component
                Table, // Adding Table component
                toolbar, // Adding toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Permission check for menu access
        if (!devConfig.getPermAction('betShopManagementConfigurationGenerateTokenMenu', 'Menu')) {
            this.show('./betShopManagement.configuration.securityChanges'); // Redirect if no permission
        } else {
            return {
                type: 'wide', // Setting layout type to wide
                cols: [left], // Adding left layout
            };
        }
    }
}

// FILE DOCUMENTED
